import { useAnalysisJobs, useAnalysisAutoRecover } from '@/hooks/useScriptAnalysis';

// Watchdog global de análisis. Montado una sola vez en el shell (AppLayout) para
// que funcione en CUALQUIER página: mientras haya un job en curso, `useAnalysisJobs`
// hace polling (8s) y el watchdog reanuda automáticamente cualquier job sin latido
// (>75s en `processing`) o en `needs_continue`. Garantía: un análisis nunca se
// queda trabado, aunque el self-invoke del edge muera a mitad. No renderiza nada.
export default function AnalysisWatchdog() {
  const { data: jobs } = useAnalysisJobs();
  useAnalysisAutoRecover(jobs);
  return null;
}
